import React, {Component} from 'react';
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import {Collapse, Label} from 'reactstrap';
import Select from 'react-select';
import 'datatables.net';
import 'datatables.net-responsive';
import "../../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../../assets/css/react-confirm-alert/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import {Link} from 'react-router-dom';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class UnMappedData extends Component {
    constructor(props){
        super(props);
        this.state = {
            unmapped_files : [],
            unmappedData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status:'',
                user_type: ''
            },
            unmappedModel: false,
            data:[],
            loading:true,
            _notificationSystem: null,
            versions:[],
            tableLists:[],
            newRelationModel: false,
            relationData: [{ tables:"", columnLists:"", columns:"", id:"", relationToTables:"", toTables:"", toColumnLists:"", toColumns:"" }],
            deleteKeys:[],
            user_id: null,
            map_status: null,
            stored_file_name: null,
            file_name: null,
            userGroup: null,
            mapField: false,
            selectedSKU: "sku",
            selectedPrice: "mrp",
            selectedDescription: [{ value: "brand", label: "Brand" }], 
            skuOptions: [
                { value: 'sku', label: 'SKU' },
                { value: 'product_code', label: 'Product_Code' },
                { value: 'level_1', label: 'Level_1' },
                { value: 'level_2', label: 'Level_2' },
                { value: 'level_3', label: 'Level_3' },
                { value: 'level_4', label: 'Level_4' },
                { value: 'mrp', label: 'MRP' },
                { value: 'mop', label: 'MOP' }
            ],
            priceOptions: [
                { value: 'sku', label: 'SKU' },
                { value: 'product_code', label: 'Product_Code' },
                { value: 'level_1', label: 'Level_1' },
                { value: 'level_2', label: 'Level_2' },
                { value: 'level_3', label: 'Level_3' },
                { value: 'level_4', label: 'Level_4' },
                { value: 'mrp', label: 'MRP' },
                { value: 'mop', label: 'MOP' },
            ],

            descriptionOptions: [
                { value: 'brand', label: 'Brand' },
                { value: 'category', label: 'Category' },
                { value: 'level_1', label: 'Level_1' },
                { value: 'level_2', label: 'Level_2' },
                { value: 'level_3', label: 'Level_3' },
                { value: 'level_4', label: 'Level_4' },
                { value: 'sku', label: 'SKU' },
                { value: 'product_code', label: 'Product_Code' }
            ],
            id: null
        };
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        //this._getVersions();
        this._refreshUnmapped();
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
    }

    setDescription = (optionSelected) => {
        this.setState({ selectedDescription: optionSelected });
        console.log(this.state.selectedDescription)
    };
    updateSKU = (optionSelected) => {
        this.setState({ selectedSKU: optionSelected.value })
    };
    updatePrice = (optionSelected) => {
        this.setState({ selectedPrice: optionSelected.value })
    };
    sendMappingColumns = (event) => {
        event.preventDefault();
        console.log(this.state.file_name);
        const data = new FormData();
        data.append('skuCol', this.state.selectedSKU);
        data.append('priceCol', this.state.selectedPrice);
        data.append('descriptionCol', JSON.stringify(this.state.selectedDescription));
        data.append('file_id', this.state.id);
        data.append('user_id', this.state.user_id);
        data.append('map_status', this.state.map_status);
        console.log(this.state.stored_file_name);
        data.append('stored_file_name', this.state.stored_file_name);
        data.append('userGroup', this.state.userGroup);
    
        console.log("data===>", data);
        if (this.state.selectedSKU != null ||
            this.state.selectedPrice != null ||
            this.state.selectedDescription != []) {
            axios.post(config.get('API_URL')+"/brandemi/upload_final", data, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
                .then(res => {
                    console.log(res);
                    if (res.data.success) {
                        this.handleNotificationClick("tr", 1, res.data.success);
                        console.log("inside if and success");
                        console.log(res.data.notify);
                        this.updateMapVisiblity(false); 
                    } else {
                        this.handleNotificationClick("tr", 3, res.data.error);
                        console.log("inside if and error")
                    }
                })
                .catch(err => { 
                    this.handleNotificationClick("tr", 3, "Something Wrong!");
                    console.log("inside if and catch")
                })
        }
        else {
            this.handleNotificationClick("tr", 3, "Please Map all Fields");
            console.log("inside else")
        }
    };

    unmappedData(id, user_id, file_name, file_path, timestamp, version, cur_version, status, user_type) {
        this.setState({
            unmappedData: {
                id,
                user_id,
                file_name,
                file_path,
                timestamp,
                version,
                cur_version,
                status,
                user_type
            },
            unmappedModel: !this.state.unmappedModel
            //login_type:loginType
        });
        this._RawData(user_id, file_name, timestamp)
        //this.findGroups(userType);
        //this.findAccessKeys(id);
    }


    toggleunmappedModel() {
        this.setState({
            unmappedModel: !this.state.unmappedModel
        })
    }

    _refreshUnmapped() {
        if ($.fn.DataTable.isDataTable('#unmappedTable')) {
            $('#unmappedTable').DataTable().destroy();
        }
        axios.get(config.get('API_URL')+'/brandemi/get_unmapped',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
            }).then(response => {
            console.log(response);
            this.setState({
                unmapped_files: response.data
            });
            $('#unmappedTable').DataTable();
            this.setState({
                loading: false
            })

        });
    }

    mapData(id, map_status, stored_file_name, user_type, user_id, file_name){
        this.setState({
            id: id,
            map_status: map_status,
            stored_file_name: stored_file_name,
            userGroup: user_type,
            user_id: user_id,
            file_name: file_name
        });
        this.openSectionToMap(true);
    }

    openSectionToMap = (status) => {
        console.log(this.state.userGroup);
        this.setState({
            mapField: status
        })
    };

    updateMapVisiblity = (value) => {
        console.log(JSON.stringify(value));
        this.setState({
            mapField: value
        })
    };
    
    render() {
        let customStyles = {
            control: provided => ({
                ...provided,
                padding: "0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),

        };

        let flexBox = {
            display: 'flex'
        };

        let unmapped_data = this.state.unmapped_files.map((unmapped,index) => {
            return (
                <tr key={index + 1}>
                    <td>{index + 1}</td>
                    <td>{unmapped.user_id}</td>
                    <td>{unmapped.file_name}</td>
                    <td>{unmapped.user_type}</td>
                    <td>{unmapped.record_update_timestamp}</td>
                    <td>
                        <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                        <Link className="viewButton" data-tip="View"  to={"/admin/merchant-viewer/" + unmapped.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                        &nbsp;
                        <Link className="viewButton" data-tip="Map Data" onClick={this.mapData.bind(this, unmapped.id, unmapped.map_status, unmapped.stored_file_name, unmapped.user_type, unmapped.user_id, unmapped.file_name)}><span className="glyphicon glyphicon-th-list"></span></Link>
                    </td>
                </tr>
            )
        });

        let file_namea = this.state.file_name;
        //styles={customStyles}

        return(
            <div className="card-query-builder">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                    <div className="content">
                        <div className='sweet-loading'>
                            <BeatLoader
                                css={override}
                                sizeUnit={"px"}
                                size={20}
                                color={'#123abc'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="content table-full-width table-responsive">
                            <table className="table table-striped table-hover" id="unmappedTable">
                                <thead>
                                <tr>
                                    <th>Sr_No.</th>
                                    <th>User_ID</th>
                                    <th>File_Name</th>
                                    <th>User_Type</th>
                                    <th>Timestamp</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                    {unmapped_data}
                                </tbody>
                            </table>
                        </div>
                    <Collapse isOpen={this.state.mapField}>
                        <div className="card">
                            <div className="header">
                                <h4 className="title">Map Fields</h4>
                                <hr/>
                            </div>
                                <div className="content">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <h5>Mapping for file: {file_namea}</h5>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                                <Label for="skuCol">Select column for Product SKU</Label>
                                                <Select name="skuCol"
                                                    isClearable={false} 
                                                    options={this.state.skuOptions}
                                                    defaultValue={this.state.skuOptions[0]}
                                                    placeholder="SKU"
                                                    onChange={this.updateSKU}
                                                />
                                            
                                        </div>
                                </div>
                                <div className="row buttonpadding">
                                    <div className="col-md-4">
                                        <Label for="descriptionCol">Select columns for Product Description </Label>
                                        <Select name="descriptionCol"
                                            isClearable={false}
                                            options={this.state.descriptionOptions}
                                            defaultValue={this.state.descriptionOptions[0]}
                                            placeholder="Description" isMulti
                                            onChange={this.setDescription}
                                        />
                                    </div>
                                </div>
                                <div className="row buttonpadding">
                                    <div className="col-md-4">
                                            <Label for="priceCol">Select column for Product Price</Label>
                                            <Select name="priceCol"
                                                isClearable={false}
                                                options={this.state.priceOptions}
                                                defaultValue={this.state.priceOptions[6]}
                                                placeholder="Price"
                                                onChange={this.updatePrice}
                                            />
                                    </div>
                                </div>
                                <div className="row buttonpadding">
                                    <div className="col-md-12">
                                        <button type="submit" className="btn btn-primary" onClick={this.sendMappingColumns}>Done</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Collapse>
                    <div className="footer">
                        <div className="stats"><i></i></div>
                    </div>
                </div>
            </div>
        );
    }
}

/*
class MapFields extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedSKU: "sku",
            selectedPrice: "mrp",
            selectedDescription: [{ value: "brand", label: "Brand" }],
            skuOptions: [
                { value: 'sku', label: 'SKU' },
                { value: 'product_code', label: 'Product_Code' }],
            
                skuOptions: [
                { value: 'sku', label: 'SKU' },
                { value: 'product_code', label: 'Product_Code' },
                { value: 'level_1', label: 'Level_1' },
                { value: 'level_2', label: 'Level_2' },
                { value: 'level_3', label: 'Level_3' },
                { value: 'level_4', label: 'Level_4' },
                { value: 'mrp', label: 'MRP' },
                { value: 'mop', label: 'MOP' }],
                
               
                priceOptions: [
                { value: 'sku', label: 'SKU' },
                { value: 'product_code', label: 'Product_Code' },
                { value: 'level_1', label: 'Level_1' },
                { value: 'level_2', label: 'Level_2' },
                { value: 'level_3', label: 'Level_3' },
                { value: 'level_4', label: 'Level_4' },
                { value: 'mrp', label: 'MRP' },
                { value: 'mop', label: 'MOP' },
                ],
                
            descriptionOptions: [
                { value: 'brand', label: 'Brand' },
                { value: 'category', label: 'Category' },
                { value: 'level_1', label: 'Level_1' },
                { value: 'level_2', label: 'Level_2' },
                { value: 'level_3', label: 'Level_3' },
                { value: 'level_4', label: 'Level_4' },
                { value: 'sku', label: 'SKU' },
                { value: 'product_code', label: 'Product_Code' }]
        }
    }
    setDescription = (optionSelected) => {
        this.setState({ selectedDescription: optionSelected });
        console.log(this.state.selectedDescription)
    }
    updateSKU = (optionSelected) => {
        this.setState({ selectedSKU: optionSelected.value })
    }
    updatePrice = (optionSelected) => {
        this.setState({ selectedPrice: optionSelected.value })
    }
    sendMappingColumns = (event) => {
        event.preventDefault()
        console.log(this.props.file_name);
        const data = new FormData();
        data.append('skuCol', this.state.selectedSKU);
        data.append('priceCol', this.state.selectedPrice);
        data.append('descriptionCol', JSON.stringify(this.state.selectedDescription));
        data.append('file_id', this.props.id);
        data.append('user_id', this.props.user_id);
        data.append('map_status', this.props.map_status);
        console.log(this.props.stored_file_name);
        data.append('stored_file_name', this.props.stored_file_name);
        data.append('userGroup', this.props.userGroup);
    
        console.log("data===>", data);
        if (this.state.selectedSKU != null ||
            this.state.selectedPrice != null ||
            this.state.selectedDescription != []) {
            axios.post(config.get('API_URL')+"/invoice/upload_final", data, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
                .then(res => {
                    console.log(res);
                    if (res.data.success) {
                        this.props.handleNotificationClick("tr", 1, res.data.success);
                        console.log("inside if and success");
                        console.log(res.data.notify);
                        this.props.updateMapVisiblity(false); 
                    } else {
                        this.props.handleNotificationClick("tr", 3, res.data.error);
                        console.log("inside if and error")
                    }
                })
                .catch(err => { 
                    this.props.handleNotificationClick("tr", 3, "Something Wrong!");
                    console.log("inside if and catch")
                })
        }
        else {
            this.props.handleNotificationClick("tr", 3, "Please Map all Fields");
            console.log("inside else")
        }
    };

    render() {

        let customStyles = {
            control: provided => ({
                ...provided,
                padding: "0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),

        };

        let flexBox = {
            display: 'flex'
        };


        return 
    }
}*/

export default UnMappedData;